import { useContext } from 'react';
import I18n from 'I18n';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { And, Or } from '../../filterQueryFormat/logic/FilterLogicGroup';
import { Select } from 'foundations-components/transitional/components/Select';
import { LogicGroupNames } from '../../filterQueryFormat/logic/LogicGroup';
import { useOnChangeHandlers } from '../../hooks/useOnChangeHandlers';
import { jsx as _jsx } from "react/jsx-runtime";
const TopLevelLogicGroupToggle = () => {
  const {
    internalDraftValue,
    dispatch
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    handleOnChange
  } = useOnChangeHandlers();
  const getTopLevelLogicGroup = () => {
    return (internalDraftValue === null || internalDraftValue === void 0 ? void 0 : internalDraftValue.logicGroupName) || LogicGroupNames.OR;
  };
  const handleTopLevelLogicGroupChange = e => {
    const newLogicGroupName = e.target.value;
    if (internalDraftValue) {
      const newInternalDraftValue = newLogicGroupName === LogicGroupNames.AND ? And.ofRoot().merge(internalDraftValue.set('logicGroupName', newLogicGroupName)) : Or.ofRoot().merge(internalDraftValue.set('logicGroupName', newLogicGroupName));
      dispatch({
        type: 'internalDraftValue',
        payload: newInternalDraftValue
      });
      handleOnChange(newInternalDraftValue);
    }
  };
  return (
    /*#__PURE__*/
    // Prevent closing parent filter groups that are opened in edit mode (showAllFiltersInEditMode)
    _jsx("strong", {
      onClick: e => e.stopPropagation(),
      children: /*#__PURE__*/_jsx(Select, {
        "data-test-id": "fr-top-level-logic-group-toggle",
        value: getTopLevelLogicGroup(),
        onChange: handleTopLevelLogicGroupChange,
        options: [{
          value: LogicGroupNames.AND,
          text: I18n.text('newCustomerDataFilters.logicOperator.and')
        }, {
          value: LogicGroupNames.OR,
          text: I18n.text('newCustomerDataFilters.logicOperator.or')
        }],
        buttonUse: "transparent"
      })
    })
  );
};
export default TopLevelLogicGroupToggle;